export const ADMIN_LOGIN_PATH = '/admin';
export const role = {
    admin: 'admin',
    doctor: 'doctor'
};
